import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function InstallmentsPage() {
  return (
    <MainLayout>
      <SEO 
        title="Parcelas a receber"
        description="Gerencie parcelas a receber de serviços"
        keywords="parcelas, receber, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Parcelas a receber</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

